<div class="flex-column">
    <div class="flex align-items-center justify-content-between">
        <app-select-button
            [form]="filteringForm"
            id="unread"
            prefix="layout.notifications.filter."
            [options]="unreadOptions"
        ></app-select-button>
        <div>
            <ng-template #actionsBtn>
                <app-button
                    icon="pi-ellipsis-v"
                    severity="secondary"
                    [outlined]="true"
                    [disabled]="!hasItems()"
                ></app-button>
            </ng-template>
            <app-drop-down-menu
                [target]="actionsBtn"
                [items]="actionsMenu()"
                [disabled]="!hasItems()"
            ></app-drop-down-menu>
        </div>
    </div>

    <div class="flex-column gap pt-2 mt-2 notifications-container">
        @for (task of activeTasks(); track task.id) {
            <div class="notification-item">
                <app-background-task-item
                    [task]="task"
                ></app-background-task-item>
            </div>
        }

        @for (item of feedItems(); track item.kind + ':' + item.id) {
            @if (item.kind === 'backgroundTask') {
                <div class="notification-item">
                    <app-background-task-item
                        [task]="item.task"
                    ></app-background-task-item>
                </div>
            } @else {
                @let notification = item.notification;
                @let severity =
                    notification.severity || NotificationSeverity.INFO;
                <div class="notification-item">
                    <div class="flex align-items-center gap">
                        <a
                            class="cursor-pointer"
                            [pTooltip]="
                                (notification.isRead
                                    ? 'layout.notifications.actions.unread'
                                    : 'layout.notifications.actions.read'
                                ) | translate
                            "
                            (click)="handleReadStatus(notification, $event)"
                        >
                            <i
                                [class]="
                                    'pi ' +
                                    (notification.isRead
                                        ? 'pi-circle'
                                        : 'pi-circle-on')
                                "
                            ></i>
                        </a>

                        <a
                            [routerLink]="notification.link"
                            class="flex-column flex-1 gap-x-small text-color notification-content"
                        >
                            <div
                                class="overflow-hidden text-overflow-ellipsis"
                                [class.font-bold]="!notification.isRead"
                            >
                                {{
                                    'layout.notifications.types.' +
                                        notification.type | translate
                                }}
                            </div>
                            @if (notification.subtitle) {
                                <span
                                    class="font-size-small overflow-hidden text-color-secondary text-overflow-ellipsis white-space-nowrap"
                                >
                                    {{
                                        notification.subtitle
                                            | translate
                                                : (notification | parseParams)
                                    }}
                                </span>
                            }
                            <span
                                class="font-size-x-small text-color-secondary"
                            >
                                {{
                                    notification.createdAt
                                        | localDate: 'dd.MM.yyyy HH:mm:ss'
                                }}
                            </span>
                        </a>

                        <div
                            class="flex-column align-items-end justify-content-between align-self-stretch gap-x-small"
                        >
                            <p-tag
                                [severity]="notificationTagSeverity[severity]"
                                [icon]="'pi ' + notificationTagIcon[severity]"
                                [value]="
                                    'messages.severity.' +
                                        notificationTagLabel[severity]
                                        | translate
                                "
                            ></p-tag>
                            <button
                                type="button"
                                class="notification-delete text-danger cursor-pointer"
                                [attr.aria-label]="
                                    'tooltips.delete' | translate
                                "
                                [pTooltip]="'tooltips.delete' | translate"
                                (click)="handleRemove(notification, $event)"
                            >
                                <i class="pi pi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            }
        }

        @if (!hasItems() && !notificationsScroll().loading()) {
            <app-empty-state [emptyState]="emptyState"></app-empty-state>
        }

        <app-infinite-scroll-load-on-screen
            [infiniteScroll]="notificationsScroll()"
        ></app-infinite-scroll-load-on-screen>
    </div>
</div>
